import { List as IList } from 'immutable';
import { createSelector } from 'reselect';
import { getFlowProgress } from '../routing/flowSelectors';
import { getShowProgramSelection } from './programListSelectors';
import { PROGRAM_CODE } from '../item/newItemForm';



export const programStepCompleted = createSelector(
    getFlowProgress,
    getShowProgramSelection,
    (flowState, showProgramSelection) => !showProgramSelection || flowState.has(PROGRAM_CODE)
);

export const programStepPostConditions = IList([
    programStepCompleted
]);
